// Google Analytics 4 - Utilidades de tracking
// Measurement ID: G-3WKZMH4B8G

export const GA_TRACKING_ID = 'G-3WKZMH4B8G';

/**
 * Trackea una vista de página
 * @param {string} url - La URL de la página
 * @param {string} title - El título de la página
 */
export const trackPageView = (url, title) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
            page_path: url,
            page_title: title,
        });
    }
};

/**
 * Trackea un evento personalizado
 * @param {string} eventName - Nombre del evento
 * @param {object} params - Parámetros adicionales
 */
export const trackEvent = (eventName, params = {}) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
    }
};

// Eventos predefinidos para la aplicación
export const events = {
    // Evento cuando se envía el formulario de contacto
    contactFormSubmit: () => trackEvent('contact_form_submit', {
        event_category: 'engagement',
        event_label: 'Formulario de contacto enviado'
    }),

    // Evento cuando se abre una historia
    storyOpen: (storyTitle) => trackEvent('story_open', {
        event_category: 'content',
        event_label: storyTitle,
        story_title: storyTitle
    }),

    // Evento cuando se hace clic en navegación
    navigationClick: (linkName) => trackEvent('navigation_click', {
        event_category: 'navigation',
        event_label: linkName,
        link_name: linkName
    }),

    // Evento cuando se hace clic en redes sociales
    socialClick: (platform) => trackEvent('social_click', {
        event_category: 'social',
        event_label: platform,
        platform: platform
    }),

    // Evento cuando se ve un producto
    productView: (productName, productId) => trackEvent('product_view', {
        event_category: 'products',
        event_label: productName,
        product_id: productId
    }),

    // Evento cuando se inicia una reserva
    reservationStart: (productName, productId) => trackEvent('reservation_start', {
        event_category: 'conversion',
        event_label: productName,
        product_id: productId
    }),

    // Evento cuando se completa una reserva
    reservationComplete: (productName, productId) => trackEvent('reservation_complete', {
        event_category: 'conversion',
        event_label: productName,
        product_id: productId
    }),

    // Evento de busqueda de productos
    productSearch: (searchTerm) => trackEvent('product_search', {
        event_category: 'search',
        event_label: searchTerm
    }),

    // Evento cuando se filtra por categoria
    filterCategory: (category) => trackEvent('filter_category', {
        event_category: 'filters',
        event_label: category || 'all',
        category: category
    }),

    // Evento cuando se cambia el ordenamiento
    filterSort: (sortOption) => trackEvent('filter_sort', {
        event_category: 'filters',
        event_label: sortOption,
        sort_option: sortOption
    }),

    // Evento cuando se activa/desactiva filtro de promo
    filterPromoToggle: (isActive) => trackEvent('filter_promo_toggle', {
        event_category: 'filters',
        event_label: isActive ? 'activated' : 'deactivated',
        promo_filter_active: isActive
    }),

    // Evento cuando se limpian los filtros
    filterClear: () => trackEvent('filter_clear', {
        event_category: 'filters',
        event_label: 'all_filters_cleared'
    }),
};
